import { render, staticRenderFns } from "./ForteenTable.vue?vue&type=template&id=d1f4645c&"
import script from "./ForteenTable.vue?vue&type=script&lang=js&"
export * from "./ForteenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports